import React, { useEffect, useState } from 'react';
import Service from '../Service/Service';

const Services = () => {
    const [diseases, setDisease]= useState([]);
    useEffect(()=>{
        fetch('./fakeData.json')
        .then(res=>res.json())
        .then(data=> setDisease(data))
    },[])
    return (
        <div className="container">
        <h1 className="text-danger">Various Types of Services We Provide</h1>
            <h3 className="text-info pt-5">OUR SPECIAL SERVICES</h3>
           
        <div className="row row-cols-1 row-cols-md-2 g-4">
            {
              diseases.map(disease=><Service key={disease.id} disease={disease}></Service>)
            }
        </div>
        </div>
    );
};

export default Services;